<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <radio-horizontal
      required
      v-if="form.status == 2 || isNew"
      v-model="form.status_actual" :error="form.errors.status_actual"
      class="pr-6 pb-8 w-full lg:w-1/2" :options="status_actuals"
      :label="$t('treatmentlogements.status_actual')"
    />
    <radio-horizontal
      v-if="(form.status == 2 || isNew) && form.status_actual == 2"
      v-model="form.type" :error="form.errors.type"
      class="pr-6 pb-8 w-full lg:w-1/2" :options="types"
      :label="$t('interventions.intervention_type')"
      :required="(form.status == 2 || isNew) && form.status_actual == 2"
    />
    <text-input
      type="date"
      :date-not-in-future="true"
      v-model="form.date_start" :error="form.errors.date_start"
      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('treatmentlogements.date_start')" :required="true"
    />
    <text-input
      v-if="(form.status == 3 || isNew)"
      type="date"
      :date-not-in-future="true"
      :required="(form.status == 3 && !isNew)"
      v-model="form.date_end" :error="form.errors.date_end"
      class="pb-8 pr-6 w-full lg:w-1/2" :label="$t('treatmentlogements.date_end')"
    />
    <textarea-input v-model="form.notes" :error="form.errors.notes" class="pb-8 pr-6 w-full lg:w-4/4"
                    :label="$t('treatmentlogements.notes')"
    />
    <div class="w-full lg:w-4/4">
      <select-dropdown v-if="!isNew" v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/4"
                       :options="statuses" :label="$t('applications.status')"
      />
    </div>
  </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import selectDropdown from '@/Shared/SelectDropdown'
import radioHorizontal from '@/Shared/RadioHorizontal'

export default {
  components: {
    TextInput,
    selectDropdown,
    radioHorizontal,
    TextareaInput
  },
  props: ['formData', 'statuses', 'isNew', 'status_actuals', 'types'],
  computed: {
    form() {
      return this.formData
    },
  },
  watch: {
    'form.status_actual'(status){
      if (status == 2) {
        this.form.type = this.form.date_start = this.form.date_end = ''
      }
    }
  }
}
</script>
